module.exports = __webpack_public_path__ + "fc81609f5ab484f14533dd1f204df919.jpg";